export function normalizeRole(role: string | undefined) {
  return role?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
